export default function PromoteEventHero() {
  return (
    <section className="relative bg-gradient-to-br from-emerald-50 via-white to-teal-50 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <i className="ri-megaphone-line text-lg"></i>
            <span>Reach Thousands of Local Residents</span>
          </div>
          
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Promote Your Event to the Roseville Community
          </h1>
          
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Get your event in front of thousands of engaged Roseville residents. From concerts to fundraisers, workshops to festivals — we'll help you fill seats and drive attendance.
          </p>
          
          <div className="flex flex-wrap items-center justify-center gap-4 mb-12">
            <a 
              href="#pricing" 
              className="bg-emerald-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap inline-flex items-center gap-2"
            >
              <span>View Pricing</span>
              <i className="ri-arrow-right-line"></i>
            </a>
            <a 
              href="#examples" 
              className="bg-white text-gray-700 px-8 py-4 rounded-lg font-semibold hover:bg-gray-50 transition-colors border-2 border-gray-200 whitespace-nowrap"
            >
              See Examples
            </a>
          </div>
          
          <div className="grid grid-cols-3 gap-8 max-w-2xl mx-auto">
            <div className="text-center">
              <div className="text-3xl font-bold text-emerald-600 mb-2">50K+</div>
              <div className="text-sm text-gray-600">Monthly Visitors</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-emerald-600 mb-2">15K+</div>
              <div className="text-sm text-gray-600">Newsletter Subscribers</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-emerald-600 mb-2">85%</div>
              <div className="text-sm text-gray-600">Local Engagement Rate</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}